import { HeroBackground } from '@prishapolicy/shared/ui';
import { NextSeo } from 'next-seo';
import Link from 'next/link';

const resourceCards = [
  {
    heading: 'Insurer Resources',
    description:
      'Download policy wordings, forms, checklists, and insurer-specific material to support underwriting, servicing, and settlement workflows.',
    href: '/resources/insurance-resources/insurer-resources',
    cta: 'Open Insurer Resources',
  },
  {
    heading: 'Client Servicing Resources',
    description:
      'Access claim process notes, templates, and practical playbooks for smoother customer servicing and handoffs.',
    href: '/resources/client-servicing-resources',
    cta: 'Open Client Servicing Resources',
  },
];

const InsuranceResources = () => {
  return (
    <>
      <NextSeo
        title="Resources | PrishaPolicy"
        description="Explore insurer and client servicing resources in one place."
      />
      <HeroBackground backgroundColor="yellow-200">
        <div className="container mt-16 mb-9 text-center">
          <h1 className="heading-1">Resources</h1>
          <h5 className="heading-5 mt-6 mb-9">
            Choose your primary workflow path and continue to the right resource center.
          </h5>
        </div>
      </HeroBackground>
      <section className="container pb-16">
        <div className="grid gap-6 pt-8 md:grid-cols-2">
          {resourceCards.map((card) => (
            <Link href={card.href} key={card.heading} className="block">
              <div className="rounded-large border-grey-200 bg-white p-6 transition hover:border-primary hover:bg-grey-100">
                <h3 className="heading-3">{card.heading}</h3>
                <p className="text-grey-700 mt-3">{card.description}</p>
                <p className="text-body-5 mt-4 font-semibold text-primary">{card.cta}</p>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </>
  );
};

export default InsuranceResources;
